const REGEX_DIACRITICOS = new RegExp("[" + String.fromCharCode(0x0300) + "-" + String.fromCharCode(0x036f) + "]", "g");

export const quitarDiacriticos = (texto) => texto.normalize("NFD").replace(REGEX_DIACRITICOS, "");
